import { createAction, props } from '@ngrx/store';
import { Zones, ZonesDTO, ZonesFilters } from '../../commons/models/zone';

export const loadZones = createAction('[Zones] Load Zones', props<{ page?: number, perPage?: number, order?: string, direction?: string, filters?: ZonesFilters, includes?: string[] }>());
export const loadZonesCompleted = createAction('[Zones] Load Zones Completed', props<{ zones: ZonesDTO[], currentPage: number, total: number, perPage: number, order?: string, direction?: string, filters?: ZonesFilters, includes?: string[] }>());
export const loadZonesFailed = createAction('[Zones] Load Zones Failed', props<{ error: any }>());

export const changePage = createAction('[Zones] Change page', props<{ page: number, size: number }>());
export const changeSort = createAction('[Zones] Change sort', props<{ order: string, direction: string }>());
export const changeFilters = createAction('[Zones] Change filters', props<{ filters: ZonesFilters }>());

export const editZone = createAction('[Zones] Edit time slot', props<{ zone: Zones }>());
export const zonesDialogOpened = createAction('[Zones] Detail dialog opened', props<{ dialogId: string }>());
export const closeZonesDialog = createAction('[Zones] Close detail dialog');
export const requestCloseZonesDialog = createAction('[Zones] Request Close Dialog');
export const confirmCloseZonesDialog = createAction('[Zones] Confirm Close Dialog');
export const cancelCloseZonesDialog = createAction('[Zones] Cancel Close Dialog');


export const showZones = createAction('[Zones] Show time slot', props<{ zone: ZonesDTO }>());
export const addZones = createAction('[Zones] Add time slot');
export const loadZone = createAction('[Zones] Load time slot', props<{ id: number }>());
export const loadZoneCompleted = createAction('[Zones] Load time slot Completed', props<{ zone: ZonesDTO }>());
export const loadZoneFailed = createAction('[Zones] Load time slot Failed', props<{ error: any }>());

export const saveZone = createAction('[Zones] Save time slot', props<{ zones: Zones }>());
export const saveZoneCompleted = createAction('[Zones] Save time slot completed', props<{ zone: ZonesDTO }>());
export const saveZoneFailed = createAction('[Zones] Save time slot failed', props<{ error: any }>());

export const deleteZone = createAction('[Zones] Delete time slot', props<{ zone: ZonesDTO }>());
export const deleteZoneCompleted = createAction('[Zones] Delete time slot completed', props<{ zone: ZonesDTO }>());
export const deleteZoneCancelled = createAction('[Zones] Delete time slot cancelled');
export const deleteZoneFailed = createAction('[Zones] Delete time slot failed', props<{ error: any }>());

export const selectZone = createAction('[Zones] Select time slot', props<{ filters?: ZonesFilters }>());
export const selectionDialogOpened = createAction('[Zones] Selection dialog opened', props<{ selectionDialogId: string }>());
export const closeSelectionDialog = createAction('[Zones] Close selection dialog');
export const zonesSelected = createAction('[Zones] Time slot selected', props<{ zone: ZonesDTO }>());

export const addSelectZones = createAction('[Zones] Add selected time slot', props<{ zone: Zones }>());
export const removeSelectedZones = createAction('[Zones] Remove selected time slots', props<{ zone: Zones }>());
export const resetSelectedZones = createAction('[Zones] Reset selected time slots');
export const selectZoneSuccess = createAction('[Zones] Select time slot Success', props<{ zone: Zones }>());

export const proceedWithSaveZone = createAction('[Zone] Proceed with Save', props<{ zones: Zones }>());





